import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import injectSagas from 'helpers/injectSagas'
import CSSModules from 'helpers/CSSModulesUtil'
import Dialog from 'react-toolbox/lib/dialog'

import PartnerSiteTeam from 'containers/Admin/PartnerSite/PartnerSiteRole/PartnerSiteTeam'

import {
    setInactivePfpsDialog,
    saveSupportTeam,
    deletePfpsSupportTeam
} from 'containers/Admin/PartnerSite/PartnerSiteProductFamily/actions'
import {
  postSiteRoles,
  resetSiteRolesChange
} from 'containers/Admin/PartnerSite/PartnerSiteRole/actions'
import {
  activeDialogSelector
} from 'containers/Admin/PartnerSite/PartnerSiteProductFamily/selectors'

const mapStateToProps = (state) => {
  return {
    active: activeDialogSelector(state)
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    toggleInactiveDialog: () => {
      dispatch(resetSiteRolesChange());
      dispatch(setInactivePfpsDialog());
    },
    onSave: () => dispatch(saveSupportTeam()),
    onDelete: () => dispatch(deletePfpsSupportTeam())
  }
}

class ProductFamilyDialog extends Component {
  onCancel = () => this.props.toggleInactiveDialog()
  onSave = () => {
    this.props.onSave()
    this.props.toggleInactiveDialog()
  }

  onDelete = () => {
    this.props.onDelete()
    this.props.toggleInactiveDialog()
  }

  actions = [
    { label: 'Delete', onClick: this.onDelete },
    { label: 'Save', onClick: this.onSave },
    { label: 'Cancel', onClick: this.onCancel },
  ]

  render() {
    const {
      active,
      toggleInactiveDialog,
    } = this.props

    return (
      <Dialog
        actions={this.actions}
        active={active}
        title='Product Family Support Team'
        onOverlayClick={toggleInactiveDialog}
        onEscKeyDown={toggleInactiveDialog}
      >
        <PartnerSiteTeam includeAeRegion={false}/>
      </Dialog>
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

export default compose(
  withConnect,
)(ProductFamilyDialog)
